module.exports = __webpack_public_path__ + "static/sport/bgi-pc.0621a3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/bgi-pc.jpg
// module id = ywxt
// module chunks = 0